export default "__VITE_ASSET__fr2k2qsx__"